import React from 'react';
import './CSS/Clientes.css';

function Clientes() {
  const clientes = [
    {
      image: '/assets/images/charly_client.JPG',
      comment: '¡Hola! Soy Charlie y gracias al trato de AyAVET me encuentro mejor ¡Guau!'
    },
    {
      image: '/assets/images/jack_client.JPG',
      comment: '¡Buenas! Soy Jack y estoy encantado con AyAVET ¡Guau!'
    },
    {
      image: '/assets/images/happy_client.JPG',
      comment: '¿Qué tal? Soy Happy y mis primeros checkeos los hago en AyAVET ¡Miau!'
    },
    {
      image: '/assets/images/turron_client.JPG',
      comment: '¿Como estás? Soy Coco y en AyAVET me controlan mi peso ¡Miau!'
    }
  ];

  return (
    <section id="clientes" className="clientes-section">
      <h1>Nuestros Pacientes</h1>
      <div className="clientes-container">
        {clientes.map((cliente, index) => (
          <div key={index} className="cliente-card">
            <img src={cliente.image} alt={`Cliente ${index + 1}`} className="cliente-image" />
            <p className="cliente-comment">{cliente.comment}</p>
          </div>
        ))}
      </div>
    </section>
  );
}

export default Clientes;